import { Clock, Phone } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { trackEvent } from "../analytics";

const WHATSAPP_NUMBER = "40749994040";
const PHONE_DISPLAY = "+40 749 994 040";

const WhatsAppIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className="h-7 w-7"
    aria-hidden="true"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { t, language } = useLanguage();
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    t.whatsapp.message
  )}`;

  return (
    <div
      className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2"
      data-testid="whatsapp-widget"
    >
      <div
        className="hidden items-center gap-2 border border-[#e2e8f0] bg-white px-3 py-1.5 text-xs font-semibold text-[#0d2b52] shadow-sm sm:flex"
        data-testid="whatsapp-hours"
      >
        <Clock className="h-3.5 w-3.5 text-[#25D366]" />
        {t.whatsapp.hours}
      </div>
      <a
        href={`tel:${WHATSAPP_NUMBER}`}
        onClick={() => trackEvent("call_click", { language })}
        aria-label={`${t.whatsapp.callLabel}: ${PHONE_DISPLAY}`}
        title={`${t.whatsapp.callLabel}: ${PHONE_DISPLAY}`}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#0d2b52] text-white shadow-lg transition-transform duration-200 hover:scale-110"
        data-testid="call-button"
      >
        <Phone className="h-6 w-6" />
      </a>
      <a
        href={href}
        onClick={() => trackEvent("whatsapp_click", { language })}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t.whatsapp.label}
        title={t.whatsapp.label}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-200 hover:scale-110"
        data-testid="whatsapp-button"
      >
        <span className="absolute h-14 w-14 animate-ping rounded-full bg-[#25D366] opacity-20" aria-hidden="true" />
        <WhatsAppIcon />
      </a>
    </div>
  );
};
